"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var batch_1 = require("../batch");
var logActionUpdate = function (config, storeName, actionName) {
    var log = config.log;
    if (!log || typeof log !== 'function' || !actionName)
        return;
    var actionLog = actionName === '_link'
        ? ' in reaction to linked store update'
        : " by action `".concat(actionName, "()`");
    log("Store \"".concat(storeName, "\" updated") +
        actionLog +
        ((0, batch_1.isBatching)() ? ' as part of batch' : ''));
};
exports.default = logActionUpdate;
//# sourceMappingURL=logActionUpdate.js.map